import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import CustomSelect from '../../../ui/CustomSelect';

const categoryOptions = [
  { value: 'technical', label: 'Technical' },
  { value: 'soft_skill', label: 'Soft Skill' },
  { value: 'managerial', label: 'Managerial' },
  { value: 'language', label: 'Bahasa' },
  { value: 'certification', label: 'Sertifikasi' },
];

const levelOptions = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' },
  { value: 'expert', label: 'Expert' },
];

const statusOptions = [
  { value: 'active', label: 'Aktif' },
  { value: 'inactive', label: 'Tidak Aktif' },
];

export default function SkillModal({ open, data, saving, onClose, onSave }) {
  const [form, setForm] = useState(data || {});

  useEffect(() => {
    setForm(data || {});
  }, [data]);

  if (!open) return null;

  const handleSubmit = e => {
    e.preventDefault();
    onSave(form);
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-hidden animate-modal">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">{form?.id ? 'Edit' : 'Tambah'} Skill</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 space-y-4 max-h-[60vh] overflow-y-auto">
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Nama Skill <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={form?.name || ''}
                onChange={e => setForm({ ...form, name: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Kategori <span className="text-red-500">*</span>
              </label>
              <CustomSelect
                value={form?.category || 'technical'}
                onChange={val => setForm({ ...form, category: val })}
                options={categoryOptions}
                placeholder="Pilih kategori"
                width="w-full"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Level</label>
              <CustomSelect
                value={form?.level || 'beginner'}
                onChange={val => setForm({ ...form, level: val })}
                options={levelOptions}
                placeholder="Pilih level"
                width="w-full"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Status</label>
              <CustomSelect
                value={form?.status || 'active'}
                onChange={val => setForm({ ...form, status: val })}
                options={statusOptions}
                placeholder="Pilih status"
                width="w-full"
              />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">Deskripsi</label>
            <textarea
              value={form?.description || ''}
              onChange={e => setForm({ ...form, description: e.target.value })}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 font-medium"
          >
            Batal
          </button>
          <button
            onClick={handleSubmit}
            disabled={saving}
            className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 disabled:opacity-50 font-medium"
          >
            {saving ? 'Menyimpan...' : 'Simpan'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
